import React from 'react'

export default function Page404() {
  return (
    <div>Error 404! (Page Not Found)</div>
  )
}
